<kpd-collapse-panel [title]="application.name" [collapsed]="false">
  <div *ngFor="let role of application.roles" class="toggle-panel list-item" [ngClass]="{'form2--invalid': role.error}">
    <kpd-toggle class="toggle" [(ngModel)]="role.hasRole" [loading]="role.loading" *ngIf="!readOnly"
      [disabled]="role.readOnly" (change)="onValueChange(role)"></kpd-toggle>
    <label class="label">{{ role.role }}</label>
    <kpd-spinner type="inline" *ngIf="role.loading" class="toggle-panel__spinner"></kpd-spinner>
    <div class="form2__error" *ngIf="role.error">
      <clr-icon class="form2__error-icon" shape="error-standard"></clr-icon>
      <div class="form2__error-message">
        {{ role.error }}
      </div>
    </div>
  </div>
</kpd-collapse-panel>
